export enum ConcretingApprovalMessages {
  stepDetailsText = "concretingApproval.stepDetailsText",
  stepActionsText = "concretingApproval.stepActionsText",
  stepMessagesText = "concretingApproval.stepMessagesText",
  dialogTitleText = "concretingApproval.dialogTitleText",
  dialogButtonSubmitText = "concretingApproval.dialogButtonSubmitText",
  actionsStatusFieldLabel = "concretingApproval.actionsStatusFieldLabel",
  actionsObservationFieldLabel = "concretingApproval.actionsObservationFieldLabel",
  concretingRequestStatusApproved = "concretingApproval.concretingRequestStatusApproved",
  concretingRequestStatusRejected = "concretingApproval.concretingRequestStatusRejected",
  concretingRequestStatusPending = "concretingApproval.concretingRequestStatusPending",
  messageInputPlaceholder = "concretingApproval.messageInputPlaceholder"
}

export interface TranslationConcretingApprovalMessages {
  [ConcretingApprovalMessages.stepDetailsText]: string;
  [ConcretingApprovalMessages.stepActionsText]: string;
  [ConcretingApprovalMessages.stepMessagesText]: string;
  [ConcretingApprovalMessages.dialogTitleText]: string;
  [ConcretingApprovalMessages.dialogButtonSubmitText]: string;
  [ConcretingApprovalMessages.actionsObservationFieldLabel]: string;
  [ConcretingApprovalMessages.actionsStatusFieldLabel]: string;
  [ConcretingApprovalMessages.concretingRequestStatusApproved]: string;
  [ConcretingApprovalMessages.concretingRequestStatusRejected]: string;
  [ConcretingApprovalMessages.concretingRequestStatusPending]: string;
  [ConcretingApprovalMessages.messageInputPlaceholder]: string;
}
